'use client';

import { ContactInfoSection } from './sections/ContactInfoSection';
import ContactFormSection from './sections/ContactFromSection';

export default function ContactContent() {
  return (
    <>
      {/* Contact Information Section */}
      <ContactInfoSection />
      <ContactFormSection />
    </>
  );
}
